import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, vModelText as _vModelText, withModifiers as _withModifiers, withKeys as _withKeys, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-318c0ba6"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "card card-flush pt-3 mb-5 mb-xl-10" }
const _hoisted_2 = { class: "card-header" }
const _hoisted_3 = { class: "card-title" }
const _hoisted_4 = { class: "fw-bolder" }
const _hoisted_5 = { class: "card-toolbar" }
const _hoisted_6 = { class: "card-body pt-3" }
const _hoisted_7 = { class: "mb-10" }
const _hoisted_8 = { class: "d-flex flex-wrap py-5" }
const _hoisted_9 = { class: "flex-equal me-5" }
const _hoisted_10 = {
  class: "table fs-6 fw-bold gs-0 gy-2 gx-2 m-0",
  style: {"table-layout":"fixed","width":"100%"}
}
const _hoisted_11 = { class: "text-gray-400 min-w-175px w-200px" }
const _hoisted_12 = { class: "svg-icon svg-icon-1 svg-icon-gray" }
const _hoisted_13 = { class: "text-gray-800 min-w-200px text-hover-gray" }
const _hoisted_14 = { class: "text-gray-400 min-w-175px w-200px" }
const _hoisted_15 = { class: "svg-icon svg-icon-1 svg-icon-warning" }
const _hoisted_16 = { class: "text-gray-800 min-w-200px text-hover-primary" }
const _hoisted_17 = { key: 0 }
const _hoisted_18 = { class: "text-gray-400" }
const _hoisted_19 = { class: "svg-icon svg-icon-1 svg-icon-danger" }
const _hoisted_20 = { class: "text-gray-800" }
const _hoisted_21 = { class: "text-gray-400" }
const _hoisted_22 = { class: "svg-icon svg-icon-1 svg-icon-success" }
const _hoisted_23 = { class: "text-gray-800" }
const _hoisted_24 = { class: "text-gray-400" }
const _hoisted_25 = { class: "svg-icon svg-icon-1 svg-icon-primary" }
const _hoisted_26 = { class: "badge-light-primary badge fs-7 px-5 fw-bolder text-gray-400" }
const _hoisted_27 = { class: "text-gray-400" }
const _hoisted_28 = { class: "svg-icon svg-icon-1 svg-icon-warning" }
const _hoisted_29 = { class: "text-gray-800" }
const _hoisted_30 = {
  key: 0,
  class: "badge-light-primary bg-light-primary badge fs-7 p-2 fw-bolder"
}
const _hoisted_31 = { class: "mt-10" }
const _hoisted_32 = { class: "text-gray-400" }
const _hoisted_33 = { class: "svg-icon svg-icon-1 svg-icon-warning" }
const _hoisted_34 = { colspan: "2" }
const _hoisted_35 = ["innerHTML"]
const _hoisted_36 = { class: "text-gray-400" }
const _hoisted_37 = { class: "svg-icon svg-icon-1 svg-icon-info" }
const _hoisted_38 = {
  key: 0,
  class: "text-gray-800"
}
const _hoisted_39 = { class: "overflow-auto pb-5" }
const _hoisted_40 = { class: "row border border-dashed border-gray-300 rounded p-5" }
const _hoisted_41 = ["href"]
const _hoisted_42 = ["alt", "src"]
const _hoisted_43 = {
  class: "fw-bold",
  style: {"display":"inline"}
}
const _hoisted_44 = ["href"]
const _hoisted_45 = {
  key: 1,
  class: "text-gray-400"
}
const _hoisted_46 = { key: 2 }
const _hoisted_47 = { class: "text-gray-400" }
const _hoisted_48 = { class: "svg-icon svg-icon-1 svg-icon-primary" }
const _hoisted_49 = { class: "text-gray-800" }
const _hoisted_50 = { class: "overflow-auto pb-5" }
const _hoisted_51 = { class: "d-flex flex-row bd-highlight mb-3 row" }
const _hoisted_52 = { class: "text-gray-400" }
const _hoisted_53 = { class: "svg-icon svg-icon-1 svg-icon-gray" }
const _hoisted_54 = {
  key: 0,
  class: "badge-light-danger bg-light-danger badge fs-7 p-2"
}
const _hoisted_55 = {
  key: 1,
  class: "badge-light-success bg-light-success badge fs-7 p-2"
}
const _hoisted_56 = {
  key: 2,
  class: "badge-light-info bg-light-info badge fs-7 p-2"
}
const _hoisted_57 = { key: 3 }
const _hoisted_58 = { class: "text-gray-400" }
const _hoisted_59 = { class: "svg-icon svg-icon-1 svg-icon-gray" }
const _hoisted_60 = ["innerHTML"]
const _hoisted_61 = { class: "mb-0" }
const _hoisted_62 = { class: "mb-4" }
const _hoisted_63 = { class: "card-body pb-0" }
const _hoisted_64 = { class: "mb-7" }
const _hoisted_65 = { class: "d-flex align-items-center mb-5" }
const _hoisted_66 = { class: "btn btn-sm btn-light btn-color-muted btn-active-light-success px-4 py-2 me-4" }
const _hoisted_67 = { class: "svg-icon svg-icon-3" }
const _hoisted_68 = { class: "mb-2 ps-10" }
const _hoisted_69 = { class: "symbol symbol-45px me-5" }
const _hoisted_70 = ["src", "alt"]
const _hoisted_71 = { class: "d-flex flex-column flex-row-fluid mb-3" }
const _hoisted_72 = { class: "d-flex align-items-center flex-wrap mb-1" }
const _hoisted_73 = {
  key: 0,
  class: "text-gray-800 text-hover-primary fw-bolder me-2"
}
const _hoisted_74 = { class: "text-gray-400 fw-bold fs-7" }
const _hoisted_75 = ["innerHTML"]
const _hoisted_76 = ["onClick"]
const _hoisted_77 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "separator mb-4" }, null, -1))
const _hoisted_78 = { class: "position-relative mb-6" }
const _hoisted_79 = { class: "row" }
const _hoisted_80 = { class: "col-11" }
const _hoisted_81 = ["placeholder"]
const _hoisted_82 = { class: "col-1" }
const _hoisted_83 = { class: "svg-icon svg-icon-1 mb-3 mx-auto" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_inline_svg = _resolveComponent("inline-svg")!
  const _component_el_image = _resolveComponent("el-image")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("h2", _hoisted_4, _toDisplayString(_ctx.t("course.infoCourse")), 1)
      ]),
      _createElementVNode("div", _hoisted_5, [
        (_ctx.course.status != 'validated')
          ? (_openBlock(), _createBlock(_component_router_link, {
              key: 0,
              to: `/classe/${_ctx.classID}/editCourse/${_ctx.courseID}`,
              class: "btn btn-light-primary"
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.t("course.edit")), 1)
              ]),
              _: 1
            }, 8, ["to"]))
          : _createCommentVNode("", true),
        _createElementVNode("button", {
          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.confirmDelete && _ctx.confirmDelete(...args))),
          class: "btn btn-light-danger mx-5"
        }, _toDisplayString(_ctx.t("course.delete")), 1)
      ])
    ]),
    _createElementVNode("div", _hoisted_6, [
      _createElementVNode("div", _hoisted_7, [
        _createElementVNode("div", _hoisted_8, [
          _createElementVNode("div", _hoisted_9, [
            _createElementVNode("table", _hoisted_10, [
              _createElementVNode("tr", null, [
                _createElementVNode("td", _hoisted_11, [
                  _createElementVNode("span", _hoisted_12, [
                    _createVNode(_component_inline_svg, { src: "media/icons/duotune/general/gen007.svg" })
                  ]),
                  _createTextVNode(" " + _toDisplayString(_ctx.t("notes.trimester")) + " : ", 1)
                ]),
                _createElementVNode("td", _hoisted_13, _toDisplayString(_ctx.course.trimester == "0"
                      ? _ctx.t("course.allTrimesters")
                      : `${_ctx.t("notes.trimester")} ${_ctx.course.trimester}`), 1)
              ]),
              _createElementVNode("tr", null, [
                _createElementVNode("td", _hoisted_14, [
                  _createElementVNode("span", _hoisted_15, [
                    _createVNode(_component_inline_svg, { src: "media/icons/duotune/general/gen003.svg" })
                  ]),
                  _createTextVNode(" " + _toDisplayString(_ctx.t("course.subject")) + " : ", 1)
                ]),
                _createElementVNode("td", _hoisted_16, _toDisplayString(_ctx.course.subject), 1)
              ]),
              (_ctx.course.module)
                ? (_openBlock(), _createElementBlock("tr", _hoisted_17, [
                    _createElementVNode("td", _hoisted_18, [
                      _createElementVNode("span", _hoisted_19, [
                        _createVNode(_component_inline_svg, { src: "media/icons/duotune/general/gen017.svg" })
                      ]),
                      _createTextVNode(" " + _toDisplayString(_ctx.t("course.module")) + " : ", 1)
                    ]),
                    _createElementVNode("td", _hoisted_20, _toDisplayString(_ctx.course.module), 1)
                  ]))
                : _createCommentVNode("", true),
              _createElementVNode("tr", null, [
                _createElementVNode("td", _hoisted_21, [
                  _createElementVNode("span", _hoisted_22, [
                    _createVNode(_component_inline_svg, { src: "media/icons/duotune/general/gen005.svg" })
                  ]),
                  _createTextVNode(" " + _toDisplayString(_ctx.t("course.title")) + " : ", 1)
                ]),
                _createElementVNode("td", _hoisted_23, _toDisplayString(_ctx.course.title), 1)
              ]),
              _createElementVNode("tr", null, [
                _createElementVNode("td", _hoisted_24, [
                  _createElementVNode("span", _hoisted_25, [
                    _createVNode(_component_inline_svg, { src: "media/icons/duotune/general/gen014.svg" })
                  ]),
                  _createTextVNode(" " + _toDisplayString(_ctx.t("course.publicationDate")) + " : ", 1)
                ]),
                _createElementVNode("td", _hoisted_26, _toDisplayString(_ctx.moment(_ctx.course.createdAt).format("YYYY/MM/DD, H:mm")), 1)
              ]),
              _createElementVNode("tr", null, [
                _createElementVNode("td", _hoisted_27, [
                  _createElementVNode("span", _hoisted_28, [
                    _createVNode(_component_inline_svg, { src: "media/icons/duotune/communication/com006.svg" })
                  ]),
                  _createTextVNode(" " + _toDisplayString(_ctx.t("course.specificFor")) + " : ", 1)
                ]),
                _createElementVNode("td", _hoisted_29, [
                  (_ctx.studentList.length == 0)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_30, _toDisplayString(_ctx.t("course.allStudent")), 1))
                    : (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList(_ctx.studentList, (student) => {
                        return (_openBlock(), _createElementBlock("span", {
                          key: student._id,
                          class: "badge-light bg-light-info badge fs-7 p-2 mx-1 mb-2 fw-bolder"
                        }, _toDisplayString(student.firstName) + " " + _toDisplayString(student.lastName), 1))
                      }), 128))
                ])
              ]),
              (_ctx.course.desc)
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                    _createElementVNode("tr", _hoisted_31, [
                      _createElementVNode("td", _hoisted_32, [
                        _createElementVNode("span", _hoisted_33, [
                          _createVNode(_component_inline_svg, { src: "media/icons/duotune/art/art005.svg" })
                        ]),
                        _createTextVNode(" " + _toDisplayString(_ctx.t("course.description")) + " : ", 1)
                      ])
                    ]),
                    _createElementVNode("tr", null, [
                      _createElementVNode("td", _hoisted_34, [
                        _createElementVNode("div", {
                          innerHTML: _ctx.course.desc,
                          class: "ms-10"
                        }, null, 8, _hoisted_35)
                      ])
                    ])
                  ], 64))
                : _createCommentVNode("", true),
              _createElementVNode("tr", null, [
                _createElementVNode("td", _hoisted_36, [
                  _createElementVNode("span", _hoisted_37, [
                    _createVNode(_component_inline_svg, { src: "media/icons/duotune/files/fil003.svg" })
                  ]),
                  _createTextVNode(" " + _toDisplayString(_ctx.t("course.resources")) + " : ", 1)
                ]),
                (_ctx.course.files.length != 0)
                  ? (_openBlock(), _createElementBlock("td", _hoisted_38, [
                      _createElementVNode("div", _hoisted_39, [
                        _createElementVNode("div", _hoisted_40, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.course.files, (file) => {
                            return (_openBlock(), _createElementBlock("div", {
                              key: file,
                              class: "col-4 pb-2"
                            }, [
                              _createElementVNode("a", {
                                target: "_blank",
                                href: _ctx.getFileLink(file)
                              }, [
                                _createElementVNode("img", {
                                  alt: _ctx.getShortFileName(file),
                                  class: "w-30px h-30px me-2",
                                  src: `media/files/${_ctx.getFileIconName(file)}.png`
                                }, null, 8, _hoisted_42)
                              ], 8, _hoisted_41),
                              _createElementVNode("div", _hoisted_43, [
                                _createElementVNode("a", {
                                  target: "_blank",
                                  href: _ctx.getFileLink(file),
                                  class: "fs-6 text-hover-primary fw-bolder"
                                }, _toDisplayString(_ctx.getShortFileName(file)), 9, _hoisted_44)
                              ])
                            ]))
                          }), 128))
                        ])
                      ])
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.course.files.length == 0)
                  ? (_openBlock(), _createElementBlock("td", _hoisted_45, _toDisplayString(_ctx.t("course.noResources")), 1))
                  : _createCommentVNode("", true)
              ]),
              (_ctx.course.photos.length != 0)
                ? (_openBlock(), _createElementBlock("tr", _hoisted_46, [
                    _createElementVNode("td", _hoisted_47, [
                      _createElementVNode("span", _hoisted_48, [
                        _createVNode(_component_inline_svg, { src: "media/icons/duotune/files/fil003.svg" })
                      ]),
                      _createTextVNode(" " + _toDisplayString(_ctx.t("course.photos")) + " : ", 1)
                    ]),
                    _createElementVNode("td", _hoisted_49, [
                      _createElementVNode("div", _hoisted_50, [
                        _createElementVNode("div", _hoisted_51, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.course.photos, (photo) => {
                            return (_openBlock(), _createElementBlock("div", {
                              class: "p-2 bd-highlight col-2",
                              key: photo
                            }, [
                              _createVNode(_component_el_image, {
                                style: {"width":"150px","height":"150px"},
                                src: photo,
                                "preview-src-list": _ctx.course.photos,
                                "initial-index": 0,
                                fit: "cover"
                              }, null, 8, ["src", "preview-src-list"])
                            ]))
                          }), 128))
                        ])
                      ])
                    ])
                  ]))
                : _createCommentVNode("", true),
              _createElementVNode("tr", null, [
                _createElementVNode("td", _hoisted_52, [
                  _createElementVNode("span", _hoisted_53, [
                    _createVNode(_component_inline_svg, { src: "media/icons/duotune/general/gen037.svg" })
                  ]),
                  _createTextVNode(" " + _toDisplayString(_ctx.t("course.review")) + " : ", 1)
                ]),
                _createElementVNode("td", null, [
                  (_ctx.course.status == 'rejected')
                    ? (_openBlock(), _createElementBlock("span", _hoisted_54, _toDisplayString(_ctx.t("course.rejectedFilter")) + " - " + _toDisplayString(_ctx.moment(_ctx.course.reviewDate).format("YYYY/MM/DD, H:mm")), 1))
                    : (_ctx.course.status == 'validated')
                      ? (_openBlock(), _createElementBlock("span", _hoisted_55, _toDisplayString(_ctx.t("course.validatedFilter")) + " -" + _toDisplayString(_ctx.moment(_ctx.course.reviewDate).format("YYYY/MM/DD, H:mm")), 1))
                      : (_openBlock(), _createElementBlock("span", _hoisted_56, _toDisplayString(_ctx.t("course.notValidatedFilter")), 1))
                ])
              ]),
              (_ctx.course.reviewNote)
                ? (_openBlock(), _createElementBlock("tr", _hoisted_57, [
                    _createElementVNode("td", _hoisted_58, [
                      _createElementVNode("span", _hoisted_59, [
                        _createVNode(_component_inline_svg, { src: "media/icons/duotune/general/gen005.svg" })
                      ]),
                      _createTextVNode(" " + _toDisplayString(_ctx.t("course.reason")) + " : ", 1)
                    ]),
                    _createElementVNode("td", {
                      innerHTML: _ctx.course.reviewNote
                    }, null, 8, _hoisted_60)
                  ]))
                : _createCommentVNode("", true)
            ])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_61, [
        _createElementVNode("h5", _hoisted_62, _toDisplayString(_ctx.t("comment.comments")), 1),
        _createElementVNode("div", _hoisted_63, [
          _createElementVNode("div", _hoisted_64, [
            _createElementVNode("div", _hoisted_65, [
              _createElementVNode("a", _hoisted_66, [
                _createElementVNode("span", _hoisted_67, [
                  _createVNode(_component_inline_svg, { src: "media/icons/duotune/communication/com012.svg" })
                ]),
                _createTextVNode(" " + _toDisplayString(_ctx.comments.length), 1)
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_68, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.comments, (comment, index) => {
              return (_openBlock(), _createElementBlock("div", {
                key: index,
                class: "d-flex mt-5"
              }, [
                _createElementVNode("div", _hoisted_69, [
                  _createElementVNode("img", {
                    src: comment.photo,
                    alt: comment.fullName
                  }, null, 8, _hoisted_70)
                ]),
                _createElementVNode("div", _hoisted_71, [
                  _createElementVNode("div", _hoisted_72, [
                    (comment.user.role == 'teacher')
                      ? (_openBlock(), _createElementBlock("a", _hoisted_73, _toDisplayString(comment.fullName), 1))
                      : (_openBlock(), _createBlock(_component_router_link, {
                          key: 1,
                          class: "text-gray-800 text-hover-primary fw-bolder me-2",
                          to: `/student/${comment.user._id}/overview`
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(comment.fullName), 1)
                          ]),
                          _: 2
                        }, 1032, ["to"])),
                    _createElementVNode("span", _hoisted_74, _toDisplayString(_ctx.moment(comment.createdAt).fromNow()), 1)
                  ]),
                  _createElementVNode("span", {
                    innerHTML: comment.text,
                    class: "text-gray-800 fs-7 fw-normal pt-1"
                  }, null, 8, _hoisted_75),
                  (_ctx.fullName == comment.fullName)
                    ? (_openBlock(), _createElementBlock("a", {
                        key: 0,
                        class: "text-gray-400 fs-8 fw-small pt-1 text-hover-danger delete",
                        onClick: ($event: any) => (_ctx.deleteComment(comment._id))
                      }, _toDisplayString(_ctx.t("course.delete")), 9, _hoisted_76))
                    : _createCommentVNode("", true)
                ])
              ]))
            }), 128))
          ]),
          _hoisted_77,
          _createElementVNode("form", _hoisted_78, [
            _createElementVNode("div", _hoisted_79, [
              _createElementVNode("div", _hoisted_80, [
                _withDirectives(_createElementVNode("textarea", {
                  class: "form-control border-0 p-0 pe-10 resize-none min-h-25px",
                  "data-kt-autosize": "true",
                  rows: "2",
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.commentText) = $event)),
                  placeholder: _ctx.t('comment.reply'),
                  onKeydown: _cache[2] || (_cache[2] = _withKeys(_withModifiers(
//@ts-ignore
(...args) => (_ctx.sendComment && _ctx.sendComment(...args)), ["exact","prevent"]), ["enter"]))
                }, null, 40, _hoisted_81), [
                  [_vModelText, _ctx.commentText]
                ])
              ]),
              _createElementVNode("div", _hoisted_82, [
                _createElementVNode("span", {
                  onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.sendComment && _ctx.sendComment(...args))),
                  class: "btn btn-icon btn-sm btn-active-color-primary"
                }, [
                  _createElementVNode("span", _hoisted_83, [
                    _createVNode(_component_inline_svg, { src: "/media/icons/duotune/general/gen016.svg" })
                  ])
                ])
              ])
            ])
          ])
        ])
      ])
    ])
  ]))
}